(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[132],{

/***/ 3829:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/category/[category]",
      function () {
        return __webpack_require__(955);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _typography_heading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9852);
/* harmony import */ var _BlogIndexHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1561);
/* harmony import */ var _BlogIndexHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_BlogIndexHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var categoryStrings = {
    national: [
        'National Issues',
        'These issues fall under the purview of Congress and/or the President.', 
    ],
    resistbot: [
        'Resistbot Features and Releases',
        'Stay up-to-date on the newest bot features and our organization.', 
    ],
    state: [
        'State Issues',
        'Your Governor and state legislators have the power here, engage with them to make a difference.', 
    ],
    podcast: [
        'Resistbot Live',
        'Join us as we explore the issues that matter to the users of Resistbot and learn from the experts about why these issues are important to you too.', 
    ]
};
var Header = function(param) {
    var category = param.category, _level = param.level, level = _level === void 0 ? 'h2' : _level;
    var strings = categoryStrings[category];
    if (!strings) {
        return null;
    }
    var _strings = _slicedToArray(strings, 2), heading = _strings[0], body = _strings[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: _BlogIndexHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__.divider,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_heading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: level,
                size: "h2",
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: _BlogIndexHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__.subheading,
                children: body
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);
Header.propTypes = {
    category: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf([
        'national',
        'resistbot',
        'state',
        'podcast'
    ]).isRequired
};


/***/ }),

/***/ 2623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var utilities_propTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4010);
/* harmony import */ var components_portableText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8845);
/* harmony import */ var components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7641);
/* harmony import */ var _grid_cell__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8410);
/* harmony import */ var _typography_anchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8472);
/* harmony import */ var _typography_heading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9852);
/* harmony import */ var _BlogPostTile_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7271);
/* harmony import */ var _BlogPostTile_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_BlogPostTile_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var BlogPostTile = function(props) {
    var post = props.post;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_grid_cell__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: _BlogPostTile_module_scss__WEBPACK_IMPORTED_MODULE_7__.tile,
        size: 2,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_typography_anchor__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            href: post.route,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: _BlogPostTile_module_scss__WEBPACK_IMPORTED_MODULE_7__.image,
                    photo: post.mainImage,
                    height: 188,
                    width: 288,
                    sizes: "(min-width: 568px) and (max-width: 1024px) 50vw, (min-width: 1024px) 30vw, 100vw"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_heading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    as: "h3",
                    className: _BlogPostTile_module_scss__WEBPACK_IMPORTED_MODULE_7__.title,
                    size: "h2",
                    children: post.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_portableText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    blocks: post.description,
                    renderLinks: false
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogPostTile);
BlogPostTile.propTypes = utilities_propTypes__WEBPACK_IMPORTED_MODULE_1__/* .BlogPostDetailType */ .T7;


/***/ }),

/***/ 7544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utilities_propTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4010);
/* harmony import */ var components_grid_grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3219);
/* harmony import */ var _BlogPostTile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2623);





var BlogPosts = function(props) {
    var posts = props.posts;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_grid_grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: posts.map(function(post) {
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BlogPostTile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                post: post
            }, post.id));
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogPosts);
BlogPosts.propTypes = {
    posts: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(utilities_propTypes__WEBPACK_IMPORTED_MODULE_1__/* .BlogPostTileType */ .XW).isRequired
};


/***/ }),

/***/ 8410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _cell_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5249);
/* harmony import */ var _cell_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_cell_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var Cell = function(param) {
    var children = param.children, className = param.className, size = param.size;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_cell_module_scss__WEBPACK_IMPORTED_MODULE_2__.cell, _cell_module_scss__WEBPACK_IMPORTED_MODULE_2__["cell".concat(size)], className),
        children: children
    }));
};
Cell.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf([
        2,
        3
    ]).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (Cell);


/***/ }),

/***/ 3219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _grid_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var _grid_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_grid_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var Grid = function(param) {
    var children = param.children, className = param.className;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, _grid_module_scss__WEBPACK_IMPORTED_MODULE_2__.grid),
        children: children
    }));
};
Grid.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Grid);


/***/ }),

/***/ 955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ CategoryPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8492);
/* harmony import */ var components_blog_BlogPosts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7544);
/* harmony import */ var components_blog_BlogIndexHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7259);
/* harmony import */ var utilities_propTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4010);






var __N_SSG = true;
function CategoryPage(param) {
    var posts = param.posts, category = param.category;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        title: "Resistbot News",
        description: "Opinion articles from our volunteers and news about Resistbot features.",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blog_BlogIndexHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                category: category,
                level: "h1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blog_BlogPosts__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                posts: posts
            })
        ]
    }));
};
CategoryPage.propTypes = {
    posts: prop_types__WEBPACK_IMPORTED_MODULE_5___default().arrayOf(utilities_propTypes__WEBPACK_IMPORTED_MODULE_4__/* .BlogPostTileType */ .XW).isRequired,
    category: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired)
};


/***/ }),

/***/ 1561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"BlogIndexHeader_divider__lPDB4","subheading":"BlogIndexHeader_subheading___QXo7"};

/***/ }),

/***/ 7271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tile":"BlogPostTile_tile__8ptz9","title":"BlogPostTile_title__t4YVr","image":"BlogPostTile_image__mvuiA"};

/***/ }),

/***/ 5249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell_cell__pc8jm","cell2":"cell_cell2__tBopB","cell3":"cell_cell3__tAtfV"};

/***/ }),

/***/ 1664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__arx8a"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [569,193,761,465,323,531,732,774,888,179], function() { return __webpack_exec__(3829); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);